import gql from 'graphql-tag';

export default gql`
  query {
    bookshops(first: 1000) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
